@import "tailwindcss";

/*
 * Brand comes from the shared design system (issue #29) — this app no longer owns its tokens or
 * its `.brut-*` primitives. `theme.css` must sit right after `@import "tailwindcss"` so its
 * `@theme` block extends Tailwind's theme (and clears the default color palette). See
 * docs/research/29-design-system.md.
 */
@import "@lazar/design-tokens/theme.css";
@import "@lazar/design-tokens/tokens.css";
@import "@lazar/ui/brut.css";

/* App-only: patch react-datepicker (a time-tracker dependency) to match the brutalist look. */
.react-datepicker__input-container input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 2px solid var(--brut-line);
  border-radius: var(--radius-md);
  background: var(--color-paper);
  color: var(--color-ink);
  font-weight: 500;
}

@media (prefers-color-scheme: dark) {
  .react-datepicker__input-container input {
    background: var(--color-charcoal);
    color: var(--color-cream);
  }
}
